<template>
    <div class="w-full mx-auto relative flex flex-col" style="max-width: 1400px; min-height: calc(100vh - 80px);">
        <div class="p-3">
            <img src="@/assets/grid/gottesdienst.webp"
                class="w-full aspect-video max-h-[500px] object-cover rounded-md shadow-md">
        </div>
        <div class="flex flex-col md:flex-row pt-12 md:pt-24 pb-24">
            <div class="px-12 lg:px-24 text-left flex flex-col w-full md:w-[60%] gap-16 md:gap-24">
                <div>
                    <h1 class="font-written text-4xl">Gottesdienste</h1>
                    <p class="text-lg text-gray-500 mt-3">Termine</p>
                    <p class="mt-5 max-w-lg lg:max-w-xl italic">
                        Alle geplanten Termine finden Sie unteranderem in der aktuellen Ausgabe des <button
                            @click="$router.push({ path: '/', hash: '#butterfly' })"
                            class="text-primary-default hover:text-primay-hover hover:underline">Schmetterlings</button>!
                    </p>

                    <div class="mt-8" v-if="data.length == 0">
                        <p class="italic text-sm">Die Daten konnte nicht geladen werden, bitte versuche es später
                            erneut.</p>
                    </div>

                    <div class="mt-8" v-if="data.length > 0">
                        <p class="font-bold">Anstehende Termine</p>
                        <div class="flex flex-col gap-3 mt-3">
                            <template v-for="d in data" :key="d">
                                <div class="flex gap-4 items-center mb-2 mt-6">
                                    <p class="text-gray-500 mt-1">
                                        {{ d.date }}
                                    </p>
                                    <div class="h-[1px] flex-auto bg-gray-500"></div>
                                </div>
                                <template v-for="i in d.items" :key="d">
                                    <div
                                        class="bg-white rounded-md shadow-md flex flex-col gap-3 text-left overflow-hidden select-none">
                                        <div class="flex items-center justify-between px-3 py-2 bg-gray-500">
                                            <!-- <p class="text-sm text-white">{{ i.date }}</p> -->
                                            <p class="text-sm text-white">{{ i.time }}</p>
                                        </div>
                                        <div class="flex gap-10 p-3">
                                            <div>
                                                <p class="font-bold">{{ i.title }}</p>
                                                <p class="text-sm text-gray-500">Thema des Gottesdienstes</p>
                                            </div>
                                            <div class="ml-auto text-right" :title="i.location">
                                                <p>{{ i?.location.split(',').reverse()[0].replace(/\d+/g, "") }}</p>
                                                <p class="text-sm text-gray-500">Ort</p>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </template>
                        </div>

                        <p class="mt-8 italic text-right text-sm text-gray-500">Daten von <a
                                href="https://kg-rastenberg.ekmd-online.de/gottesdienste/"
                                class="hover:underline hover:text-primary-default font-bold">kg-rastenberg.ekmd-online.de</a>
                            bereitgestellt.
                        </p>
                    </div>
                </div>
            </div>
            <GridNav />
        </div>
    </div>
</template>

<script>
import GridNav from '@/components/gridNav.vue'

export default {
    name: 'Gottesdienst',
    data() {
        return {
            data: []
        }
    },
    components: {
        GridNav
    },
    async created() {
        this.data = this.groupItems(await this.$userStore.getData());
    },
    methods: {
        groupItems(data) {
            let grouped = [];
            let current = null;
            for (let i = 0; i < data.length; i++) {
                if (current == null || current.date != data[i].date) {
                    current = {
                        date: data[i].date,
                        items: []
                    };
                    grouped.push(current);
                }
                current.items.push(data[i]);
            }
            return grouped;
        }
    }
}
</script>